module.exports = __webpack_public_path__ + "media/images/menu/pegasus-21fa43c4b8909ebeeb60995aa310377b.jpg";